import React, {ReactElement} from 'react';
import {useSelector} from 'react-redux';
import {twMerge} from 'tailwind-merge';

import {PROPORTIONS} from 'App/layout/layoutConstants';
import {selectLayoutType} from 'App/layout/layoutSlice';
import {LAYOUT_TYPES} from '~/components/common/pages_constants';

type TProps = {
  content: ReactElement;
  reparentableMap: ReactElement;
};

const ModalTemplate = ({content, reparentableMap}: TProps): ReactElement => {
  const layoutType = useSelector(selectLayoutType);
  const isMapShown = layoutType !== LAYOUT_TYPES.HIDDEN;

  return (
    <div className="h-full min-h-screen bg-[#F3F6F8] p-3">
      <div
        className={twMerge(
          'grid h-full rounded-xl border bg-white',
          !isMapShown && 'mx-auto w-full',
          PROPORTIONS[layoutType],
        )}
      >
        <div className="relative overflow-auto">{content}</div>
        <div
          className={twMerge(
            'overflow-hidden rounded-xl',
            isMapShown && 'm-[20px] border border-gray-300',
          )}
        >
          {reparentableMap}
        </div>
      </div>
    </div>
  );
};

export default ModalTemplate;
